/**
 * Returns true when the given error is the "draft already exists"
 * HttpsError thrown by adminCreateNewDraft / adminCreateNewDraftStation /
 * adminCreateNewFlashcardDraft. The check is tolerant of both code- and
 * message-based shapes that the callable client may surface.
 */
export const isDraftAlreadyExistsError = (error) => {
  const code = String(error?.code || "").toLowerCase();
  const message = String(error?.message || "").toLowerCase();
  return (
    code.includes("already-exists") ||
    message.includes("draft already exists")
  );
};
